import { render, staticRenderFns } from "./OrderTypeData.vue?vue&type=template&id=3259cb9f&scoped=true&"
import script from "./OrderTypeData.vue?vue&type=script&lang=js&"
export * from "./OrderTypeData.vue?vue&type=script&lang=js&"
import style0 from "./OrderTypeData.vue?vue&type=style&index=0&id=3259cb9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3259cb9f",
  null
  
)

export default component.exports